<template>
<div>
<div @click="$emit('outside')" class="w-full h-[100vh] absolute top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
</div>
<div class="flex flex-col justify-center absolute left-0 top-[40%] mx-[40%] z-40 bg-white w-[450px] text-lg rounded-lg border-[2px] border-[#c0c0c0]">
    <div class="pafcpic_header bg-[#E3E3E3] py-3 px-6 rounded-s">
        <p class="text-[#0B6014]">Confirmation</p>
    </div>
    
    <div class="pafcpic_body py-6 px-6">
        <p class="text-sm text-[#414141]">Are you sure to add this item?</p>
    </div>
    <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t">
            <button @click="$emit('confirmation')" class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md">Yes</button>
            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md">No</button>
    </div>
    </div>
</div>
</template>